import { queryOptions, useQuery } from '@tanstack/react-query';

import { conversationsApi } from '../api/conversations-api';

import { conversationKeys } from './conversation-keys';

export function conversationQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: conversationKeys.detail(storeId, id),
    queryFn: () => conversationsApi.get(storeId, id),
  });
}

export function useConversation(storeId: string, id: string) {
  return useQuery(conversationQueryOptions(storeId, id));
}
